exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#store-event-creator.dialog__container {\n  overflow-y: auto;\n}\n#event-form .event-form-section .mdc-text-field:last-child, #event-form .event-form-section .mdc-select:last-child {\n  margin-bottom: 10px;\n}\n#event-form .event-form-section .title {\n  display: block;\n  font-size: 1.1em;\n  font-weight: 500;\n  margin: 0 5px 5px 5px;\n}\n.event-tf, .type-selector {\n  border-radius: 0;\n}\n.event-tf {\n  width: 100%;\n  flex-basis: 100%;\n}\n#type-opts.mdc-select {\n  width: 100%;\n  border-radius: 0;\n}", ""]);

// exports
